<template>
  <header class="white">
    <span
      target="_blank"
      :alt="data.name"
      :title="data.name"
      class="header__logo"
      :class="{ skip: isSkip }"
    >
      <div class="logo-mob"></div>
      <div class="logo logo-eat-size">
        <img
          :src="require(`../assets/logo/orange/${data.logo}`)"
          :alt="data.name"
          :title="data.name"
          data-aos="zoom-in"
        />
      </div>
    </span>

    <div
      v-if="data.country_toggle.length > 1"
      class="header__toggle"
      @click="showToggles = !showToggles"
    >
      <img
        :src="
          require(`../assets/country-svg/${data.country_toggle[0].logo}.svg`)
        "
        alt=""
      />
    </div>
    <div v-else class="header__toggle">
      <img
        :src="
          require(`../assets/country-svg/${data.country_toggle[0].logo}.svg`)
        "
        alt=""
      />
    </div>
    <div v-if="showToggles" class="header__toggle--list">
      <p class="title">{{ data.language }}</p>
      <a v-for="(toggle, i) in data.country_toggle" :href="toggle.url" :key="i">
        <img
          :src="require(`../assets/country-svg/${toggle.logo}.svg`)"
          alt=""
        />
        <p>{{ toggle.text }}</p>
      </a>
    </div>
  </header>
</template>

<script>
import Content from "../data/content";
let lang = process.env.VUE_APP_LOCALITY;

export default {
  name: "NavBar",
  data: function () {
    return {
      data: Content[lang].navbar,
      showToggles: false,
      isSkip: lang == "ca_en" || lang == "ca_fr" ? true : false,
    };
  },
  methods: {
    async openNav() {
      let navToggle = document.getElementById("nav-toggle");
      let header = document.getElementsByTagName("header");
      navToggle.classList.toggle("open");
      header[0].classList.toggle("open");
    },
  },
};
</script>

<style>
#body-overlay {
  background: rgba(36, 46, 48, 0.2);
  position: fixed;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  z-index: 99;
  display: none;
  overflow: hidden;
}

#body-overlay.open {
  display: block;
}

.pageContainer {
  overflow: hidden;
}

header {
  padding: 16px 32px;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  box-shadow: 0px 2px 6px 0px rgba(0, 0, 0, 0.04),
    0px 8px 12px -2px rgba(0, 0, 0, 0.06), 0px 4px 6px 0px rgba(0, 0, 0, 0.04);
  z-index: 1;
  position: relative;
}

header.open {
  background: white;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 12;
  min-height: 585px;
}

header.open .header__toggle {
  bottom: 50px;
  top: unset;
}

header.open .header__toggle--list {
  bottom: 95px;
  top: unset;
  border: 1px solid #242e30;
}

.header__logo {
  max-width: 165px;
  display: block;
  width: 100%;
}

.header__logo.skip {
  max-width: 96px;
}

#nav-toggle {
  background-image: url("../assets/icons/nav-toggle.svg");
  height: 21px;
  width: 21px;
  position: absolute;
  top: 29px;
  right: 20px;
  cursor: pointer;
  display: none;
}

#nav-toggle.open {
  background-image: url("../assets/icons/close-black.svg");
}

.header__menu {
  margin-right: 100px;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
}

.header__menu a {
  font-family: "JETSansDigital", sans-serif;
  font-weight: 700;
  font-size: 18px;
  color: #242e30;
  line-height: 120%;
  margin-right: 30px;
  text-decoration: none;
}

.header__toggle {
  max-height: 28px;
  max-width: 28px;
  height: 100%;
  width: 100%;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  cursor: pointer;
  right: 30px;
}

.header__toggle img {
  object-fit: cover;
  object-position: center;
  height: 100%;
  width: 100%;
  border-radius: 50%;
}

.header__toggle--list {
  background-color: #fff;
  padding: 10px 24px 5px;
  border-radius: 30px;
  display: flex;
  flex-direction: column;
  position: absolute;
  top: 95px;
  right: 30px;
  min-width: 152px;
  font-family: "JETSansDigital", sans-serif;
  z-index: 99;
}

.header__toggle--list a {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  margin-bottom: 25px;
  text-decoration: none;
}

.header__toggle--list a:hover p {
  color: #ff8000;
}
.header__toggle--list a:first-of-type p {
  font-weight: 600;
}

.header__toggle--list p {
  font-size: 14px;
  margin: 0 0 0 15px;
  color: #293133;
}

.header__toggle--list .title {
  font-size: 18px;
  font-weight: 600;
  margin: 0 0 15px 0;
  padding: 12px 0;
}

.header__toggle--list img {
  width: 16px;
  height: 16px;
  border-radius: 50%;
  object-fit: cover;
  margin: 0;
}

.header__nav {
  position: relative;
}

@media only screen and (max-width: 1024px) {
  header.open {
    padding: 16px 0;
  }
  .header__nav {
    height: calc(100% - 16px);
    max-height: 0;
    overflow: hidden;
    width: 100%;
  }

  header.open .header__nav {
    max-height: 100%;
    opacity: 1;
  }

  header.open .header__logo {
    padding-left: 32px;
  }
  header.open .header__nav::before {
    content: "";
    display: block;
    position: absolute;
    top: 0;
    left: 0;
    width: calc(100% + 40px);
    box-shadow: 0px 4px 6px 0px rgba(0, 0, 0, 0.04),
      0px 8px 12px -2px rgba(0, 0, 0, 0.06), 0px 2px 6px 0px rgba(0, 0, 0, 0.04);
    height: 2px;
  }

  #nav-toggle {
    display: block;
  }

  .header__menu a:first-of-type {
    display: block;
    order: 1;
  }

  .header__menu a:nth-of-type(2) {
    order: 2;
  }

  .header__menu a:nth-of-type(3) {
    order: 3;
  }

  .header__menu a:nth-of-type(4) {
    order: 4;
  }

  .header__menu a:nth-of-type(5) {
    order: 5;
  }

  .header__menu a:nth-of-type(6) {
    order: 0;
  }

  .header__menu a.grey-button,
  .header__menu a.grey-button {
    padding: 16px 30px 14px;
    max-width: 391px;
    background: #efedea;
    border-radius: 30px;
  }

  .header__nav .custom-button {
    margin: 0 auto;
    display: inline;
  }

  .header__menu {
    margin-right: 0;
    padding: 0 32px;
  }

  .header__menu a {
    text-align: center;
    width: 100%;
    font-size: 20px;
    line-height: 28px;
    margin: 20px auto;
  }
}
</style>
